import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib/core/store';
import { createSlice } from '@reduxjs/toolkit';

export const userSitesUiSlice = createSlice({
  name: 'user-sites-ui',
  initialState: {
    ...baseUiInitialState,
  },
  reducers: {
    ...baseUiReducers,
  },
});

export const selectedSitesUiSlice = createSlice({
  name: 'selected-sites-ui',
  initialState: {
    ...baseUiInitialState,
  },
  reducers: {
    ...baseUiReducers,
  },
});

export const allSitesUiSlice = createSlice({
  name: 'all-sites-ui',
  initialState: {
    ...baseUiInitialState,
    currentlyLoadedPage: 0,
  },
  reducers: {
    ...baseUiReducers,
    upsertIds: (state, { payload: newIds }: { payload: string[] }) => {
      state.loadedIds = Array.from(new Set([...state.loadedIds, ...newIds]));
    },
    setCurrentlyLoadedPage: (state, { payload: loadedPage }: { payload: number }) => {
      state.currentlyLoadedPage = loadedPage;
    },
  },
});
